import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasSummary()
    .hasThumbnail()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

schema.prop('salutation').setType(String);
schema.prop('firstName').setType(String);
schema.prop('lastName').setType(String);
schema.prop('image').setType(String);
schema.prop('jobTitle').setType(String);
schema.prop('qualifications').setType(String);
schema.prop('summary').setType(String);
schema.prop('description').setType(String);
schema.prop('appointments').setType(String);
schema.prop('memberships').setType(String);

export default schema;
